import { render } from "./CxBadge.vue?vue&type=template&id=a8ecccb4&scoped=true"
import script from "./CxBadge.vue?vue&type=script&lang=js"
export * from "./CxBadge.vue?vue&type=script&lang=js"

import "./CxBadge.vue?vue&type=style&index=0&id=a8ecccb4&lang=less&scoped=true"

import exportComponent from "/home/ec2-user/workspace/_ui2_staging_ui2-staging-0.124.0/apps/ui2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8ecccb4"]])

export default __exports__